<div class="p-para m-4"  >
    <div [innerHTML]="componentData.content"></div>
</div>
